export default "__VITE_ASSET__DYHK5NrT__"